import { BaseAnnotation } from 'cornerstone-tools';
import {
  addToolState,
  toolStyle,
  textStyle,
  store,
  PanTool,
  ScaleOverlayTool,
  ZoomTouchPinchTool,
  LengthTool,
  PanMultiTouchTool,
  addToolForElement,
  setToolActiveForElement,
  setToolDisabledForElement,
  setToolPassiveForElement,
  getToolForElement,
  getToolState,
  EVENTS,
  removeToolState,
  toolColors,
  getModule,
} from 'cornerstone-tools';
import * as cst from 'cornerstone-tools';

// Add proper typing for the import function
// @ts-ignore
export const typedCornerstoneToolsImport = cst.import as (path: string) => any;

export const lineSegDistance = typedCornerstoneToolsImport('util/lineSegDistance');
export const setShadow = typedCornerstoneToolsImport('drawing/setShadow');
export const cursors = typedCornerstoneToolsImport('tools/cursors');

export const MouseCursor = typedCornerstoneToolsImport('tools/cursors/MouseCursor');
export const BaseAnnotationTool: cst.BaseAnnotationToolCtor =
  typedCornerstoneToolsImport('base/BaseAnnotationTool');
export const moveHandleNearImagePoint = typedCornerstoneToolsImport(
  'manipulators/moveHandleNearImagePoint'
);
export const BaseBrushTool = typedCornerstoneToolsImport('base/BaseBrushTool');
export const BaseTool = typedCornerstoneToolsImport('base/BaseTool');
export const draw = typedCornerstoneToolsImport('drawing/draw');
export const getNewContext = typedCornerstoneToolsImport('drawing/getNewContext');
export const drawHandles = typedCornerstoneToolsImport('drawing/drawHandles');
export const drawLinkedTextBox = typedCornerstoneToolsImport('drawing/drawLinkedTextBox');
export const drawJoinedLines = typedCornerstoneToolsImport('drawing/drawJoinedLines');
export const drawCircle = typedCornerstoneToolsImport('drawing/drawCircle');
export const path = typedCornerstoneToolsImport('drawing/path');
export const drawLine = typedCornerstoneToolsImport('drawing/drawLine');
export const drawTextBox = typedCornerstoneToolsImport('drawing/drawTextBox');
export const clipToBox = typedCornerstoneToolsImport('util/clipToBox');
export const triggerEvent = typedCornerstoneToolsImport('util/triggerEvent');
export const getProximityThreshold = typedCornerstoneToolsImport('util/getProximityThreshold');
export const anyHandlesOutsideImage = typedCornerstoneToolsImport(
  'manipulators/anyHandlesOutsideImage'
);
export const getHandleNearImagePoint = typedCornerstoneToolsImport(
  'manipulators/getHandleNearImagePoint'
);
export const findHandleDataNearImagePoint = typedCornerstoneToolsImport(
  'manipulators/findHandleDataNearImagePoint'
);
export const throttle = typedCornerstoneToolsImport('util/throttle');
export const getLogger = typedCornerstoneToolsImport('util/getLogger');

export {
  addToolState,
  toolStyle,
  textStyle,
  toolColors,
  store,
  PanTool,
  ScaleOverlayTool,
  LengthTool,
  ZoomTouchPinchTool,
  PanMultiTouchTool,
  addToolForElement,
  setToolActiveForElement,
  setToolDisabledForElement,
  setToolPassiveForElement,
  getToolForElement,
  getToolState,
  EVENTS,
  removeToolState,
  getModule,
};
